module.exports = __webpack_public_path__ + "static/img/124.4c383d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/124.jpg
// module id = sOt5
// module chunks = 0